import React from 'react'
import classes from './WeatherDataNoInfo.module.css'

const WeatherDataNoInfo = () => {
    return (
        <div className={classes.Weather_data_no_info}>
            Enter city to get weather :)
        </div>
    )
}

export default WeatherDataNoInfo